import { render, staticRenderFns } from "./cognitiveImpairment.vue?vue&type=template&id=91db23b4&scoped=true&"
import script from "./cognitiveImpairment.vue?vue&type=script&lang=js&"
export * from "./cognitiveImpairment.vue?vue&type=script&lang=js&"
import style0 from "./cognitiveImpairment.vue?vue&type=style&index=0&id=91db23b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91db23b4",
  null
  
)

export default component.exports